import { jsx as _jsx } from "react/jsx-runtime";
// componentes
import { Chat } from "../../organisms";
export const ChatView = ({ messages, onSend, isTyping, account, }) => {
    return (_jsx(Chat, { messages: messages, isTyping: isTyping, account: account, onSend: onSend }));
};
ChatView.displayName = 'ChatView';
export default ChatView;
